import { ClientItem } from 'owa-mail-store';
import { TranslationContentType } from '../utils/TranslationContentType';

export default function getTranslationContentType(
    item: ClientItem,
    isConversationItemPart: boolean
): number {
    let contentType = TranslationContentType.Undefined;

    const bodyType = isConversationItemPart
        ? item?.UniqueBody?.BodyType
        : item?.NormalizedBody?.BodyType;

    if (bodyType === 'HTML') {
        contentType = TranslationContentType.Html;
    } else if (bodyType === 'Text') {
        contentType = TranslationContentType.PlainText;
    }

    return contentType;
}
